export const selectContent = (message) => {
  if (!window || !window.gtag) {
    return
  }
  window.gtag("event", "select_content", {
    content_type: message,
  })
}

export const search = (searchTerm) => {
  if (!window || !window.gtag) {
    return
  }
  window.gtag("event", "search", {
    search_term: searchTerm,
  })
}
